module.exports = __webpack_public_path__ + "static/media/tea-photo-topper-2.69959737.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/tea-photo-topper-2.png
// module id = 194
// module chunks = 0